import { Container, Heading, Text } from "@fluidattacks/design";
import { useTranslation } from "react-i18next";

import type { IExecutionDetailsProps } from "../types";
import { getVulnerabilitySummaries } from "../utils";

const ExecutionDetails = ({
  execution,
}: IExecutionDetailsProps): JSX.Element => {
  const { t } = useTranslation();

  const headings = [
    { id: 1, label: t("group.forces.date"), value: execution.date },
    { id: 2, label: t("group.forces.status.title"), value: execution.status },
    {
      id: 3,
      label: t("group.forces.strictness.title"),
      value: execution.strictness,
    },
    {
      id: 4,
      label: t("group.forces.severityThreshold.title"),
      value: execution.severityThreshold,
    },
    {
      id: 5,
      label: t("group.forces.gracePeriod.title"),
      value: execution.gracePeriod,
    },
    {
      id: 6,
      label: t("group.forces.daysUntilItBreaks.title"),
      value: execution.daysUntilItBreaks ?? "-",
    },
    { id: 7, label: t("group.forces.kind.title"), value: execution.kind },
    { id: 8, label: t("group.forces.gitRepo"), value: execution.gitRepo },
    {
      id: 9,
      label: t("group.forces.identifier"),
      value: execution.executionId,
    },
    {
      id: 10,
      label: t("group.forces.foundVulnerabilities.title"),
      value: getVulnerabilitySummaries(execution.vulnerabilities ?? null),
    },
  ];

  return (
    <Container
      display={"flex"}
      flexDirection={"column"}
      gap={1.25}
      justify={"space-between"}
    >
      {headings.map(
        (item, _): JSX.Element => (
          <Container
            alignItems={"center"}
            display={"flex"}
            flexDirection={"row"}
            key={item.id}
            width={"100%"}
          >
            <Heading fontWeight={"bold"} size={"xs"}>
              {t(item.label)}
            </Heading>
            <Text size={"md"}>{item.value}</Text>
          </Container>
        ),
      )}
    </Container>
  );
};

export { ExecutionDetails };
